module.exports = __webpack_public_path__ + "images/places/training_739-1c9e7d3147f863644191264fb22d8dcf.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_739.jpg
 ** module id = 328
 ** module chunks = 0
 **/